var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticStyle: { "margin-right": "20px" } }, [
    _c("i", { staticClass: "el-icon-data-analysis" }),
    _vm._v(" " + _vm._s(_vm.page) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }